import { get } from 'lodash';
import { connect } from 'react-redux';

const mapStateToProps = state => ({ siteByPass: get(state, 'query.all.bypass') });
export default Component => connect(mapStateToProps)(Component);
